var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "select-type", style: { height: _vm.viewportHeight } },
    [
      _c("HomeHeader", { attrs: { scrollTop: 300 } }),
      _c("div", { staticClass: "flex-column container w-wrapper" }, [
        false
          ? _c(
              "div",
              {
                staticClass: "back",
                on: {
                  click: function ($event) {
                    return _vm.goBack()
                  },
                },
              },
              [_vm._v("返回")]
            )
          : _vm._e(),
        _c("div", { staticClass: "flex-column main" }, [
          _c("div", { staticClass: "title" }, [_vm._v("企业MCN机构申请")]),
          _c(
            "div",
            { staticClass: "steps-box" },
            [
              _c(
                "el-steps",
                { attrs: { active: 1, "align-center": "" } },
                [
                  _c("el-step", { attrs: { title: "选择公会类型" } }),
                  _c("el-step", { attrs: { title: "填写公会信息" } }),
                  _c("el-step", { attrs: { title: "填写资质信息" } }),
                  _c("el-step", { attrs: { title: "确认信息" } }),
                  _c("el-step", { attrs: { title: "等待审核" } }),
                  _c("el-step", { attrs: { title: "完成入驻" } }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "form-box" },
            [
              _c(
                "el-form",
                {
                  ref: "ruleForm",
                  staticClass: "demo-ruleForm",
                  attrs: {
                    model: _vm.ruleForm,
                    rules: _vm.rules,
                    "label-width": "120px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "", "label-width": "0" } },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "font-weight": "bold",
                            width: "100px",
                            "text-align": "right",
                            "font-size": "16px",
                          },
                        },
                        [_vm._v("负责人信息")]
                      ),
                    ]
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "负责人姓名", prop: "contactName" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入", maxlength: "20" },
                        model: {
                          value: _vm.ruleForm.contactName,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.ruleForm,
                              "contactName",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "ruleForm.contactName",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "负责人身份", prop: "contactRole" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { placeholder: "请选择" },
                          model: {
                            value: _vm.ruleForm.contactRole,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm, "contactRole", $$v)
                            },
                            expression: "ruleForm.contactRole",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "省级代理人", value: 4 },
                          }),
                          _c("el-option", {
                            attrs: { label: "市级代理人", value: 3 },
                          }),
                          _c("el-option", {
                            attrs: { label: "区县代理人", value: 2 },
                          }),
                          _c("el-option", { attrs: { label: "无", value: 1 } }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "手机号码", prop: "contactPhone" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入", maxlength: "11" },
                        on: {
                          blur: function ($event) {
                            return _vm.getImgVerifyCodeApi()
                          },
                        },
                        model: {
                          value: _vm.ruleForm.contactPhone,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.ruleForm,
                              "contactPhone",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "ruleForm.contactPhone",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "图形验证码", prop: "code" } },
                    [
                      _c("div", { staticClass: "flex-row-h-center" }, [
                        _c(
                          "div",
                          { staticStyle: { flex: "1" } },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "请输入", maxlength: "4" },
                              model: {
                                value: _vm.ruleForm.code,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.ruleForm,
                                    "code",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "ruleForm.code",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              width: "100px",
                              "margin-left": "10px",
                              "text-align": "right",
                              cursor: "pointer",
                            },
                          },
                          [
                            _vm.ruleForm.contactPhone &&
                            _vm.ruleForm.contactPhone.length === 11 &&
                            _vm.imgCodeUrl
                              ? _c("img", {
                                  staticStyle: { width: "100px" },
                                  attrs: { src: _vm.imgCodeUrl, alt: "" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.getImgVerifyCodeApi()
                                    },
                                  },
                                })
                              : !_vm.ruleForm.contactPhone
                              ? _c("span", [_vm._v("请输入手机号")])
                              : _c("span", [_vm._v("获取图形验证码")]),
                          ]
                        ),
                      ]),
                    ]
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "短信验证码", prop: "smsCode" } },
                    [
                      _c("div", { staticClass: "flex-row-h-center" }, [
                        _c(
                          "div",
                          { staticStyle: { flex: "1" } },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "请输入", maxlength: "6" },
                              model: {
                                value: _vm.ruleForm.smsCode,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.ruleForm,
                                    "smsCode",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "ruleForm.smsCode",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticStyle: { "margin-left": "10px" } },
                          [
                            _c(
                              "el-button",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.getSMSVerifyCodeApi()
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.countdown > 0
                                      ? `${_vm.countdown}秒后重试`
                                      : "获取短信验证码"
                                  ) + " "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]),
                    ]
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "身份证照片", required: "" } },
                    [
                      _c(
                        "div",
                        { staticClass: "flex-row" },
                        [
                          _c("directUploadOne", {
                            attrs: {
                              model: "img",
                              size: "10MB",
                              defaultImgUrl: _vm.id_card_face,
                              imgUrl: _vm.ruleForm.contactIdCardFrontUrl,
                            },
                            on: {
                              success: function ($event) {
                                return _vm.ocrIdCardApi()
                              },
                              "update:imgUrl": function ($event) {
                                return _vm.$set(
                                  _vm.ruleForm,
                                  "contactIdCardFrontUrl",
                                  $event
                                )
                              },
                              "update:img-url": function ($event) {
                                return _vm.$set(
                                  _vm.ruleForm,
                                  "contactIdCardFrontUrl",
                                  $event
                                )
                              },
                            },
                          }),
                          _c("directUploadOne", {
                            staticStyle: { "margin-left": "10px" },
                            attrs: {
                              model: "img",
                              size: "10MB",
                              defaultImgUrl: _vm.id_card_country,
                              imgUrl: _vm.ruleForm.contactIdCardBackUrl,
                            },
                            on: {
                              "update:imgUrl": function ($event) {
                                return _vm.$set(
                                  _vm.ruleForm,
                                  "contactIdCardBackUrl",
                                  $event
                                )
                              },
                              "update:img-url": function ($event) {
                                return _vm.$set(
                                  _vm.ruleForm,
                                  "contactIdCardBackUrl",
                                  $event
                                )
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "身份证号码", prop: "contactIdCard" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入", maxlength: "18" },
                        model: {
                          value: _vm.ruleForm.contactIdCard,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.ruleForm,
                              "contactIdCard",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "ruleForm.contactIdCard",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "", "label-width": "0" } },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "font-weight": "bold",
                            width: "100px",
                            "text-align": "right",
                            "font-size": "16px",
                          },
                        },
                        [_vm._v("公会信息")]
                      ),
                    ]
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "公会名称", prop: "orgName" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入", maxlength: "20" },
                        on: {
                          blur: function ($event) {
                            return _vm.joinApplyNameCheckApi()
                          },
                        },
                        model: {
                          value: _vm.ruleForm.orgName,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.ruleForm,
                              "orgName",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "ruleForm.orgName",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "公会介绍", prop: "orgDescription" } },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          "show-word-limit": "",
                          rows: "5",
                          placeholder: "请输入",
                          maxlength: "200",
                        },
                        model: {
                          value: _vm.ruleForm.orgDescription,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.ruleForm,
                              "orgDescription",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "ruleForm.orgDescription",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-row",
                        { attrs: { gutter: 12 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c(
                                "el-button",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: { type: "default" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.onPre()
                                    },
                                  },
                                },
                                [_vm._v("上一步 ")]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c(
                                "el-button",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: { type: "primary" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.submitForm()
                                    },
                                  },
                                },
                                [_vm._v("下一步 ")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]),
      ]),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "请上传负责人证件",
            visible: _vm.ocrVisible,
            width: "30%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.ocrVisible = $event
            },
          },
        },
        [
          _c("div", [
            _c("div", [
              _vm._v(
                "检测到您上传的身份证照片中的姓名和负责人姓名不一致，是否覆盖负责人姓名"
              ),
            ]),
            _c(
              "div",
              {
                staticClass: "flex-row-end dialog-footer",
                attrs: { slot: "footer" },
                slot: "footer",
              },
              [
                _c(
                  "el-button",
                  {
                    on: {
                      click: function ($event) {
                        return _vm.handleConfirmOcr(1)
                      },
                    },
                  },
                  [_vm._v("不覆盖")]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.handleConfirmOcr(2)
                      },
                    },
                  },
                  [_vm._v("覆 盖")]
                ),
              ],
              1
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }